import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7281 3.88384C17.1624 2.44395 19.2604 2.41371 20.4219 3.57968C21.5856 4.74786 21.5542 6.8591 20.1189 8.29997L17.6951 10.7332C17.4028 11.0267 17.4037 11.5015 17.6971 11.7939C17.9906 12.0862 18.4655 12.0853 18.7578 11.7918L21.1816 9.35857C23.0929 7.43986 23.3329 4.37653 21.4846 2.52108C19.6342 0.663429 16.5776 0.905542 14.6653 2.82524L9.81768 7.6917C7.90639 9.61041 7.66643 12.6738 9.5147 14.5292C9.80702 14.8227 10.2819 14.8236 10.5754 14.5313C10.8688 14.2389 10.8697 13.7641 10.5774 13.4706C9.41376 12.3024 9.4451 10.1912 10.8804 8.7503L15.7281 3.88384Z"
        fill={colorValue}
      />
      <path
        d="M14.4846 9.47062C14.1923 9.17716 13.7174 9.17624 13.4239 9.46856C13.1305 9.76089 13.1296 10.2358 13.4219 10.5292C14.5856 11.6974 14.5542 13.8086 13.1189 15.2495L8.27129 20.116C6.83696 21.5559 4.73889 21.5861 3.57742 20.4202C2.41376 19.252 2.4451 17.1407 3.8804 15.6998L6.30424 13.2666C6.59657 12.9731 6.59565 12.4982 6.30219 12.2059C6.00873 11.9136 5.53386 11.9145 5.24153 12.208L2.81769 14.6412C0.906387 16.5599 0.666428 19.6233 2.5147 21.4788C4.36518 23.3364 7.42173 23.0943 9.334 21.1746L14.1816 16.3081C16.0929 14.3894 16.3329 11.3261 14.4846 9.47062Z"
        fill={colorValue}
      />
    </svg>
  );
};
